import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import Amplify from "aws-amplify";
import { AWSIoTProvider } from "@aws-amplify/pubsub";
import {
  callKeepAnswerCallEmit,
  callKeepCancelCallEmit,
} from "src/utils/event";
import { amplifyConfig, otherConfig } from "./aws-config";

Amplify.configure(amplifyConfig);

Amplify.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: otherConfig.MQTT.region,
    aws_pubsub_endpoint: otherConfig.MQTT.endpoint,
  })
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
